module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_logo-cd4c4083.png";